const e = () => !1, s = () => process.env.NODE_ENV === "development";
export {
  s as isDev,
  e as isDevInternal
};
